<template>
  <div>
    <h3 class="h2filter">Filtrar Resultados:</h3>
    <form class="radioFilterSearch">
      <h4 class="h2filter">Por:</h4>

      <md-radio class="md-primary" v-model="filter.scope" value="chapter">Capitulo</md-radio>
      <md-radio class="md-primary" v-model="filter.scope" value="profile">Perfil</md-radio>
      <md-radio class="md-primary" v-model="filter.scope" value="place">Lugar</md-radio>
      <!-- <md-checkbox v-model="filter.near">Proximo de mim</md-checkbox> -->
    </form>

    <!-- <md-button
      v-if="query.t != filter.scope"
      class="md-primary md-raised"
      :to="{}"
    >
      Aplicar filtro
    </md-button> -->

    <!-- <md-divider class="dividerSearch"></md-divider>

    <form class="radioFilterSearch">
      <h4 class="h2filter">Data do Capitulo:</h4>

      <md-radio v-model="filter.year" value="data">Qualquer Data</md-radio>
      <md-radio v-model="filter.year" value="2019">2019</md-radio>
      <md-radio v-model="filter.year" value="2018">2018</md-radio>
      <md-radio v-model="filter.year" value="2017">2017</md-radio>

      <div class="container">
        <select>
          <option value="0">Year:</option>
          <option v-for="a in years" :key="a">{{ a }}</option>
        </select>
      </div>
    </form> -->
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      filter: {
        scope: false,
        near: false,
        year: false
      },
      query: {
        s: this.$route.query.s,
        t: this.$route.query.t,
      }
    };
  },
  watch: {
    "filter.scope"(scope) {
      this.$emit("typeChange", scope);
    }
  },
  computed: {
    years() {
      const year = new Date().getFullYear();
      return Array.from({ length: year - 1900 }, (value, id) => 1901 + id);
    }
  }
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5 {
  margin: 0;
}

.CardfilterResults {
  width: 100%;
  height: calc(100vh - 50px);
  overflow-y: auto;
}

.radioFilterSearch {
  margin: 20px;
}

.md-radio {
  display: flex;
}

.dividerSearch {
  margin: 15px;
}

.divResultSearch {
  position: relative;
  float: right;
  right: 80px;
  width: 60%;
}
</style>
